import { useState } from 'react'
import {
    ClientPreviewFieldsFragment,
    useGetChatsByClientIdQuery,
} from '~graphql/generated/graphql'

export function useChatFilterValues(): ChatFilterValues {
    const [selectedClient, setSelectedClient] = useState<
        ClientPreviewFieldsFragment | undefined | null
    >(null)

    const { data, loading } = useGetChatsByClientIdQuery({
        variables: {
            clientId: selectedClient?.id || '',
        },
        skip: !selectedClient,
    })

    return {
        selectedClient,
        setSelectedClient,
        selectedChatId: data?.getChatsByClientId[0]?.id || null,
        loadingChat: loading,
    }
}

export type ChatFilterValues = {
    selectedClient: ClientPreviewFieldsFragment | null | undefined
    setSelectedClient: (
        client: ClientPreviewFieldsFragment | null | undefined,
    ) => void
    selectedChatId: string | null
    loadingChat: boolean
}
